<fs-drag-bar [header]="this.generateDeviceName(historical)" (closeDialog)="close()">
  <div class="axonListHeader"></div>
  <mat-dialog-content>
    <ng-container *ngFor="let history of historical.deviceHistory | reverseArray; let i = index">
      <div class="information-container">
        <div class="details">
          <fs-axon-notification-icon
            [content]="{ data: { notification: history.attributes } }"
            [showTooltip]="false"
          ></fs-axon-notification-icon>
          <span>
            {{ this.messages[history.attributes.category] }}
          </span>
        </div>
        <div class="time">
          <dt>{{ formatDate(history.attributes.timestamp) }}</dt>
        </div>
        <br />
      </div>
    </ng-container>

    <ng-container *ngIf="!historical.deviceHistory.length">
      <sn-empty-state icon="cancel_presentation" title="No History">
        No history available
      </sn-empty-state>
    </ng-container>
  </mat-dialog-content>
</fs-drag-bar>
